import { createSelector } from "reselect";
import { optionByLocale } from "../../utils/common-util";

export const MasterSelector = {
  state: (state) => state.constant.master,
  locale: (state) => MasterSelector.state(state).locale.locale,
  // errorConst: (state) => MasterSelector.state(state).errorConst,

  receiveMethodList: (state) => MasterSelector.state(state).receiveMethodList,
  receiveMethodOptions: createSelector(
    [
      (state) => MasterSelector.isLocaleTH(state),
      (state) => MasterSelector.receiveMethodList(state),
    ],
    (isLocaleTH, receiveMethodList) => {
      return optionByLocale(
        receiveMethodList,
        isLocaleTH,
        "receiveMethodCode",
        "receiveMethodDescTh",
        "receiveMethodDescEn"
      );
    }
  ),
  brokerList: (state) => MasterSelector.state(state).brokerList,
  brokerOptions: createSelector(
    [
      (state) => MasterSelector.isLocaleTH(state),
      (state) => MasterSelector.brokerList(state),
    ],
    (isLocaleTH, brokerList) => {
      return optionByLocale(
        brokerList,
        isLocaleTH,
        "securityCompanyCode",
        "securityCompanyNameTh",
        "securityCompanyNameEn",
        {
          isCompany: (_, option) => option.securityCompany === "Y",
          securityCompanyNameDisplay: (isThai, option) => {
            const securityCompanyName = isThai
              ? option.securityCompanyNameTh
              : option.securityCompanyNameEn;
            return `${option.securityCompanyCode.padStart(3, "0")} ${option.securityCompanyShortName} : ${securityCompanyName}`;
          },
          labelFilters: (isThai, option) => [
            isThai
              ? `${option.securityCompanyCode.padStart(3, "0")}${option.securityCompanyShortName}:${option.securityCompanyNameTh}`.toLowerCase()
              : `${option.securityCompanyCode.padStart(3, "0")}${option.securityCompanyShortName}:${option.securityCompanyNameEn}`.toLowerCase()
          ],
        }
      );
    }
  ),
  incomeSourceList: (state) => MasterSelector.state(state).incomeSourceList,
  incomeSourceOptions: createSelector(
    [
      (state) => MasterSelector.isLocaleTH(state),
      (state) => MasterSelector.incomeSourceList(state),
    ],
    (isLocaleTH, incomeSourceList) => {
      return optionByLocale(
        incomeSourceList,
        isLocaleTH,
        "incomeSourceCode",
        "incomeSourceDescTh",
        "incomeSourceDescEn"
      );
    }
  ),
  listOfOccupation: (state) => MasterSelector.state(state).listOfOccupation,
  occupationOption: createSelector(
    (state) => MasterSelector.listOfOccupation(state),
    (occupations) =>
      occupations.map((occupation) => ({
        label: occupation.occupationDescTh,
        value: occupation.occupationCode,
      }))
  ),
  listOfBranch: (state) => MasterSelector.state(state).listOfBranch,
  branchOption: createSelector(
    [(state) => MasterSelector.listOfBranch(state)],
    (branches) =>
      branches.map((branch) => ({
        label: branch.branchName,
        value: branch.branchCode,
      }))
  ),
}

export const ChatSelector = {
  state: (state) => state.chat,
  countReable : (state) => ChatSelector.state(state).countReable
}
